import {createTheme} from '@mui/material';
import {ezprOrange} from './_helpers';

export const EZPRTheme = createTheme({
    typography: {
        fontFamily: [
            'BrownPro',
            'Roboto',
        ].join(','),
    },
    palette: {
        primary: {
            main: '#999999',
        },
        secondary: {
            main: '#FFFFFF',
        },
        contrastThreshold: 3,
    },
});

export const orangeTheme = createTheme({
    typography: {
        fontFamily: [
            'BrownPro',
            'Roboto',
        ].join(','),
    },
    palette: {
        primary: {
            main: ezprOrange,
        },
        secondary: {
            main: '#FFFFFF',
        },
        contrastThreshold: 3,
    },
});
